var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"highlight-box",style:(_vm.highlightBox.style)},[_c('div',{staticClass:"highlight-name"},[_vm._v(_vm._s(_vm.highlightBox.tagName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }